let showModalRef: (() => void) | null = null;

export function registerDbNotFoundModal(fn: () => void) {
  showModalRef = fn;
}

export function unregisterDbNotFoundModal() {
  showModalRef = null;
}

export function triggerDbNotFoundModal() {
  showModalRef?.();
}

export function isDbNotFoundError(message: string | undefined): boolean {
  return typeof message === 'string' && message.startsWith('Banco de dados não encontrado');
}
